import { useState, useEffect } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import LoadingEllipsis from './LoadingEllipsis';

interface AuthLoadingProps {
    message: string;
}

export default function AuthLoading({message}: AuthLoadingProps) {
    return (
        <div className="flex items-center justify-center h-screen bg-gray-30">
            <div className="flex flex-col items-center space-y-4">
                <img src="/img/logo-dev.svg" alt="BeamXR Developer Portal" />
                <h1 className="text-lg text-white">
                    {message}
                    <LoadingEllipsis />
                </h1>
                <ArrowPathIcon
                    className="animate-spin text-white h-10 w-10"
                />
            </div>
        </div>
    );
}
